import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  type DocumentUploadRequest,
  postPartnersPartnerIDDocuments,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { PARTNERS_QUERY_KEYS } from "Partners/Api/Queries/queryKeys";

export function useUploadPartnerDocumentMutation(partnerID: string) {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    ({ file, displayName }: DocumentUploadRequest) =>
      postPartnersPartnerIDDocuments({ file, displayName }, partnerID),
    { translationPrefix: getResourcePath(Resources.ApiErrors.DocumentUpload) },
  );

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: PARTNERS_QUERY_KEYS.documents(partnerID),
      });
    },
  });
}
